import { render, staticRenderFns } from "./UserProfileInfoDetails.vue?vue&type=template&id=7ebd6fdc"
import script from "./UserProfileInfoDetails.vue?vue&type=script&lang=js"
export * from "./UserProfileInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./UserProfileInfoDetails.vue?vue&type=style&index=0&id=7ebd6fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QRating});
